/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useCreateEntityOverlayStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
  },
  title: {
    lineHeight: '38px',
    marginBottom: '40px',
    display: 'flex',
    alignItems: 'center',
  },
  h100: {
    height: '100%',
  },
  loaderContainer: {
    height: '100%',
    maxHeight: '500px',
    minHeight: '150px',
  },
  containerRoot: {
    flex: 1,
  },
  containerInner: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  assistantIcon: {
    width: '24px',
    height: '24px',
    marginLeft: '8px',
    padding: '0',
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.tertiary.main,
    },
  },
  assistantIconPlacement: {
    position: 'absolute',
    right: '100px',
  },
}));

export const useCreateEntityOverlayFormStyles = makeStyles(() => ({
  calendarAdornmentRoot: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiInputAdornment-positionEnd': {
      marginLeft: '0',
    },
  },
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    verticalAlign: 'top',
    marginTop: '20px',
    '&:first-child': {
      marginTop: 0,
    },

    '& .MuiFormHelperText-root': {
      fontSize: '12px',
      lineHeight: '16px',
      padding: '0 16px',
      '&.Mui-error': {
        color: '#FA634E',
      },
    },
  },
  widthDefault: {
    maxWidth: '240px',
    width: '100%',
  },
  datePickerField: {
    maxWidth: '300px !important',
  },
  widthMedium: {
    maxWidth: '620px',
    width: '100%',
  },
  widthFull: {
    maxWidth: '100%',
    width: '100%',
  },
  formControlLabel: {
    '& .MuiTypography-body1': {
      color: '#2C333B',
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  formTitle: {
    margin: '0 0 12px',
  },
  formControlWithLabel: {
    display: 'flex',
    verticalAlign: 'top',
    marginTop: '20px',
    '&:first-child': {
      marginTop: 0,
    },
  },
  rightFormLabel: {
    marginLeft: '20px',
  },
  mt20: {
    marginTop: '20px',
  },
}));
